import {
  purchaseRequestsResponseSchema,
  type PurchaseRequestsResponse,
  type PurchaseRequestStatus,
  type PurchaseRequestPriority,
} from '../types';
import { ApiClientError } from '@/errors';
import {
  authFetch, buildApiUrl 
} from '@/lib/api-client';

export interface PurchaseRequestFilters {
  readonly status?: PurchaseRequestStatus;
  readonly priority?: PurchaseRequestPriority;
  readonly siteId?: string;
}

export async function getPurchaseRequests(
  filters?: PurchaseRequestFilters
): Promise<PurchaseRequestsResponse> {
  const params = new URLSearchParams();
  if (filters?.status) params.set('status', filters.status);
  if (filters?.priority) params.set('priority', filters.priority);
  if (filters?.siteId) params.set('siteId', filters.siteId);

  const url = buildApiUrl('/v1/purchase-requests', params);
  const response = await authFetch(url);

  if (!response.ok) {
    throw ApiClientError.fromResponse(response, 'Failed to fetch purchase requests');
  }

  return purchaseRequestsResponseSchema.parse(await response.json());
}
